'use client'

import FloatingParticlesBackground from '@/app/[locale]/(create)/partner/components/FloatingParticlesBackground'
import ViverseButton from '@/components/ViverseButton'
import { usePartnerApply } from '@/hooks/usePartnerApply'
import { motion } from 'framer-motion'
import { useTranslations } from 'next-intl'

export default function CTAFooterSection() {
  const t = useTranslations()
  const { handleClickApplyButton } = usePartnerApply()

  return (
    <section className="relative overflow-hidden bg-linear-to-b from-[#121216] to-[#131b26]">
      <FloatingParticlesBackground />

      <div className="relative flex flex-col items-center px-4 py-12 md:px-6 md:py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className="flex w-full max-w-[720px] flex-col items-center gap-4 md:gap-6"
        >
          <h2 className="text-center text-[28px] leading-9 font-bold tracking-[-0.9px] text-white md:text-[36px] md:leading-10">
            {t.rich('partner.cta-footer.title', {
              span: (chunks) => <span className="gradient-title-2 block md:inline">{chunks}</span>,
            })}
          </h2>
          <p className="text-vive-primary-20 text-center leading-[26px] tracking-[0.25px] md:text-lg">
            {t('partner.cta-footer.subtitle')}
          </p>
          <ViverseButton
            size="medium"
            variant="colorful"
            className="mt-2 min-h-12 min-w-[196px] text-[16px] md:text-[18px]"
            onClick={handleClickApplyButton}
          >
            {t('partner.cta-footer.apply-button')}
          </ViverseButton>
        </motion.div>
      </div>
    </section>
  )
}
